<template>
  <v-navigation-drawer
    v-model="localDrawerState"
    app
    clipped
    disable-resize-watcher
    disable-route-watcher>
    <v-toolbar flat class="transparent">
      <v-list class="pa-0">
        <v-list-item two-line>
          <v-list-item-avatar>
            <v-icon>mdi-face</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ name }}</v-list-item-title>
            <v-list-item-subtitle>{{ agencyId }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-toolbar>

    <v-list class="pa-0">
      <v-list-item>
          <v-list-item-content>
            <!-- <span class="caption link" @click="updatePassword">Change Password</span> -->
            <span class="red--text caption link" @click="doLogout">Logout</span>
          </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-divider />

    <v-list class="pt-0">
      <v-list-item v-for="item in nav" :key="item.route" class="tile" @click="navTo(item.route)">
          <v-list-item-avatar v-if="item.icon">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-avatar>
        <v-list-item-action>{{ item.label }}</v-list-item-action>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<style lang="scss">
.v-list-tile-action {
  padding-left: 20px;
}

.link {
  text-decoration: underline;
  cursor: pointer;
}
</style>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      nav: [
        { label: 'Home', route: '/', icon: 'mdi-home' },
        { label: 'Search Clients', route: '/search', icon: 'mdi-account-search' },
        { label: 'Launch a Client', route: '/clientLookup', icon: 'mdi-rocket' }
      ]
    };
  },
  computed: {
    ...mapState(['selectedLineOfBusinessCode']),
    ...mapGetters('auth', [
      'isUserSignedIn',
      'userProfile'
    ]),
    localDrawerState: {
      get () {
        return this.value && this.userSignedIn;
      },
      set (localDrawerState) { this.$emit('input', localDrawerState); }
    },
    name: function () {
      return this.userProfile ? this.userProfile.initials : '';
    },
    agencyId: function () {
      return this.userProfile ? this.userProfile.agencyId : null;
    },
    clientId: function () {
      return this.$route.params.clientId;
    },
    policyOrderNumber: function () {
      return this.$route.params.policyOrderNumber;
    },
    lobCode: function () {
      return this.selectedLineOfBusinessCode;
    },
    userSignedIn: function () {
      return this.isUserSignedIn;
    }
  },
  methods: {
    ...mapActions('auth', ['logout']),
    async doLogout () {
      this.localDrawerState = false;
      await this.logout();
    },
    navTo (rte) {
      this.localDrawerState = false;
      this.$router.push(rte);
    }
  }
};
</script>
